import { AppLink } from '~/components/AppLink';
import { useTranslate } from '@tolgee/react';
import { WrapperWidget } from '@agentselly/ui';
import { Button } from '~/components/ui/Button';

interface Props {
  readonly link: string;
  readonly isAuthenticated?: boolean;
  readonly children: React.ReactNode;
  readonly menuItemTranslation?: string;
  readonly noSpace?: boolean;
}

export function PublicPopoverWidget(props: Props) {
  const { t } = useTranslate();

  return (
    <>
      {!props.isAuthenticated ? (
        <div className="relative z-30 h-full group">
          <div className="h-full cursor-pointer">
            <div className="overlay absolute inset-0 bg-black bg-opacity-60 flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-40 rounded-xl">
              <div className="text-center p-4">
                <div className="text-xl text-white mb-3">
                  {t('calculator_result_page_login_hint', {
                    menuItem: t(props.menuItemTranslation ?? ''),
                  })}
                </div>
                <div className="bg-black absolute bottom-0 right-0 w-full p-6 rounded-b-xl">
                  <AppLink
                    to={props.link}
                    data-track="immodossier valiant property information login link"
                  >
                    <Button
                      primary
                      showArrow
                    >
                      {t('clerk_login_button')}
                    </Button>
                  </AppLink>
                </div>
              </div>
            </div>
            {props.noSpace ? (
              <div className="pointer-events-none group-hover:blur-sm transition-all duration-300">
                {props.children}
              </div>
            ) : (
              <WrapperWidget>
                <div className="h-full flex flex-col gap-y-6 pointer-events-none group-hover:blur-sm transition-all duration-300">
                  {props.children}
                </div>
              </WrapperWidget>
            )}
          </div>
        </div>
      ) : props.noSpace ? (
        props.children
      ) : (
        <WrapperWidget>
          <div className="h-full flex flex-col gap-y-6">{props.children}</div>
        </WrapperWidget>
      )}
    </>
  );
}
